const Select = (props) => {
    const data = props.data;

    return (
        <>
            <div className="col-md-3">
                <label htmlFor={data.name}>{data.label} {data?.required && (<span className="text-danger">*</span>)}</label>
                <select className="form-select" name={data.name} id={data.name} value={props.state[data.name]} onChange={e => props.handleInput(e)}>
                    {data.values.map(option => (
                        <option value={option.value}>{option.label}</option>
                    ))}
                </select>
            </div>
        </>
    )
}

export default Select;